import { useEffect, useState } from "react";
import Logo from './../../assets/images/logo.png';
const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-primary" id="topbar">
        <div className="container">
          <div className="navbar-brand"></div>
          <ul className="navbar-nav">
            <li className="nav-item"><a className="nav-link" href="tel:+91 90826 67792"> <i className="fa fa-phone" /> +91 90826 67792</a></li>
            <li className="nav-item"><a className="nav-link" href="mailto: contact@visionworkspaces.com"> <i className="fa fa-envelope" /> contact@visionworkspaces.com</a></li>
            <li className="nav-item"><a className="nav-link" href="#"> <i className="fa fa-clock-o" aria-hidden="true"/> Mon - Sat: 09:00 AM - 09:00 PM</a></li>
          </ul>
        </div>
      </nav>
      {/* Navbar Start */}
      <nav className={`main-nav navbar navbar-expand-lg ${scrolled ? "nav-bg" : ""}`}>
        <div className="container-fluid">
          {/* Logo */}
          <a className="navbar-brand" href="/">
            <img className="logo-main" src={Logo} alt="logo" />
            <img className="logo-white" src={Logo} alt="logo-white" />
          </a>
          {/* Toogle Button */}
          <button className="navbar-toggler collapsed" type="button"
            data-toggle="collapse"
            data-target="#mainNav"
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <div className="collapse navbar-collapse nav-list" id="mainNav">
            {/* Navigation Links */}
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#home">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#about">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#services">
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#pricing">
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#amenities">
                  Amenities
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#gallery">
                  Gallery
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link scroll-to" href="#enquiry">
                  Enquiry
                </a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link scroll-to" href="#contact">
                  Contact Us
                </a>
              </li>
              <li className="nav-item">
                <a className="btn btn-primary btn-sm scroll-to" style={{padding:"15px 25px"}} href="#enquiry">
                Enquire Now
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Navbar End */}
    </>
  );
};
export default Navigation;